import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  static values = {parentTurboFrameId: String, endpoint: String, recordSelectorClass: String}
  hasRefreshed = true

  connect() {
    const selector = this.hasRecordSelectorClassValue ? this.recordSelectorClassValue : null
    this.hasRefreshed = this.element.querySelectorAll(selector).length === 0
    this.observer = new MutationObserver(() => this.checkEmpty())
    this.observer.observe(this.element, {childList: true, subtree: true})
    if (!this.hasRefreshed && selector)
      this.checkEmpty()
  }

  disconnect() {
    this.observer.disconnect()
  }

  checkEmpty() {
    const selector = this.hasRecordSelectorClassValue ? this.recordSelectorClassValue : null

    const isEmpty = this.element.querySelectorAll(selector).length === 0

    if (isEmpty && !this.hasRefreshed) {
      this.hasRefreshed = true
      if (this.hasParentTurboFrameIdValue)
        Glassfrog.hotwire.refreshTurboFrame(this.parentTurboFrameIdValue)
      else if (this.hasEndpointValue)
        fetch(this.endpointValue, {headers: {Accept: 'text/vnd.turbo-stream.html'}})
    } else if (!isEmpty) {
      this.hasRefreshed = false
    }
  }
}
